(function () {
    'use strict';

    if (typeof window === 'undefined') {

        expansions(
            module.exports,
            require('../../utils/timePeriod.js'),
            require('lodash')
        );
    } else {
        RivalIQ.module('models.metrics.expansions');

        expansions(
            RivalIQ.models.metrics.expansions,
            RivalIQ.utils.timePeriod,
            window._
        );
    }

    function expansions(metrics, timePeriodUtils, _) {

        // NOTE: if your expansion depends on view state, make sure you define it as a function instead of as
        // a static block. That way, your metric will still be correct if view state changes.
        const expansionData = {
            avg_engagement_rate_per_post: {
                property: 'engagement_total / presence_reach',
                orderProperty: 'avg_engagement_rate_per_post'
            },
            avg_engagement_rate_per_boosted_post: {
                property: 'engagement_total_likely_boosted / presence_reach_likely_boosted',
                orderProperty: 'avg_engagement_rate_per_boosted_post'
            },
            avg_engagement_rate_per_non_boosted_post: {
                property: 'engagement_total_non_boosted / presence_reach_non_boosted',
                orderProperty: 'avg_engagement_rate_per_non_boosted_post'
            },
            engagement_total_per_view: {
                property: 'engagement_total / views',
                orderProperty: 'engagement_total_per_view'
            },
            engagement_rate_by_estimated_impression: {
                property: 'engagement_total / estimated_impressions',
                orderProperty: 'engagement_rate_by_estimated_impression'
            },
            companies_using: function (parentMetric) {
                let extensions;
                let focusCompanyId = null;

                if (parentMetric) {
                    focusCompanyId = parentMetric.get('focusCompanyId');
                    // NOTE the `dimensionView` metric property is used in the
                    // table, and we ONLY want to remove it (by setting its
                    // value to a noop render) when the table is looking at
                    // the corresponding dimension (`companyId`)
                    if (parentMetric.get('dimension') === 'companyId') {
                        extensions = {
                            dimensionView: {
                                render: _.noop
                            }
                        };
                    }
                }

                return _.extend({
                    property: 'companyId.count',
                    orderProperty: 'companyCount',
                    invalidDimensions: ['companyId'],
                    submetrics: [
                        {
                            omit: true,
                            property: 'count',
                            companyId: focusCompanyId,
                            dimensions: ['companyId']
                        }
                    ]
                }, extensions);
            },
            shared_url_count_distinct: function (parentMetric) {
                let extensions;

                // NOTE the `dimensionView` metric property is used in the
                // table, and we ONLY want to remove it (by setting its
                // value to a noop render) when the table is looking at
                // the corresponding dimension (`canonicalUrl`)
                if (parentMetric && parentMetric.get('dimension') === 'canonicalUrl') {
                    extensions = {
                        dimensionView: {
                            render: _.noop
                        }
                    };
                }

                return _.extend({
                    property: 'shared_url_count_distinct',
                    invalidDimensions: ['canonicalUrl']
                }, extensions);
            },
            engagement_total_per_post: function (parentMetric) {
                if (parentMetric && parentMetric.dataSource === 'insightsPost') {
                    // we only want this expansion for social posts.
                    return {};
                }
                return {
                    property: 'engagement_total / count',
                    orderProperty: 'engagement_total_per_post'
                };
            },
            potential_reach: {
                property: 'presence_reach'
            }
        };

        const propertyExpansions = {
            // TODO does not handle periods where the rollup is
            // anything except 1
            period: function (metric) {
                return timePeriodUtils.getPeriodDurationsForInterval(metric.getDataTimePeriod(), 'day', false).main;
            }
        };

        metrics.expandPropertyValue = function (metric, submetric, property) {
            return (propertyExpansions[property] ? propertyExpansions[property](metric, submetric) : submetric[property]);

        };

        metrics.expandDefinition = function (attributes, parentMetric) {
            let expansion = expansionData[attributes.property];
            if (_.isFunction(expansion)) {
                expansion = expansion(parentMetric);
            }

            return (expansion ? _.create(attributes, expansion) : undefined);
        };
    }
})();
